import { type Reducer } from 'redux';

import { ACTIONS } from '@~/actions/toast-msg';
import { type INotificationToastProps } from '@cuemath/leap';

export interface IToastMessageState {
  message?: string;
  ctaList?: INotificationToastProps['ctaList'];
  timeout?: number;
  toastMetaData?: INotificationToastProps['toastMetaData'];
}

type TToastMessageAction =
  | { type: typeof ACTIONS.HIDE_TOAST_MESSAGE }
  | {
      type: typeof ACTIONS.SHOW_TOAST_MESSAGE;
      payload: {
        message: string;
        ctaList: INotificationToastProps['ctaList'] | null;
        timeout?: number | null;
        toastMetaData?: INotificationToastProps['toastMetaData'] | null;
      };
    };

const initialState: IToastMessageState = {};

const toastMessageReducer: Reducer<IToastMessageState, TToastMessageAction> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case ACTIONS.HIDE_TOAST_MESSAGE:
      return initialState;
    case ACTIONS.SHOW_TOAST_MESSAGE: {
      const { message, ctaList, timeout, toastMetaData } = action.payload;

      return {
        message,
        ctaList: ctaList ?? undefined,
        timeout: timeout ?? undefined,
        toastMetaData: toastMetaData ?? undefined,
      };
    }
    default:
      return state;
  }
};

export default toastMessageReducer;
